import React from 'react';
import { Field } from 'formik';
import { Stack } from '@nib/layout';
import { getGroupEventHandlerProps } from '../../util/propTypes';
import YesNoRadio from '../yes-no-radio';
const formName = 'hasPreExistingConditionsLeadQuestions';
const PreExistingConditionsQuestions = [{
  id: `${formName}-preEx_leadQuestion_medicalIssue`,
  name: `${formName}-preEx_leadQuestion_medicalIssue`,
  label: 'Have you ever had any medical issues or illnesses that required ongoing treatment, monitoring or review by a doctor in your entire life?'
}, {
  id: `${formName}-preEx_leadQuestion_seenSpecialistLast5Yrs`,
  name: `${formName}-preEx_leadQuestion_seenSpecialistLast5Yrs`,
  label: 'Have you ever seen a specialist doctor in the last five years?'
}, {
  id: `${formName}-preEx_leadQuestion_admittedHospitalLast5Yrs`,
  name: `${formName}-preEx_leadQuestion_admittedHospitalLast5Yrs`,
  label: 'Have you ever been admitted to hospital or had a medical procedure for any reason in the last five years?'
}, {
  id: `${formName}-preEx_leadQuestion_takenMedicationMoreMonthLast5Yrs`,
  name: `${formName}-preEx_leadQuestion_takenMedicationMoreMonthLast5Yrs`,
  label: 'Have you ever taken medication for more than one month in the last five years other than contraception?'
}];
const PreExistingConditionsLeadQuestions = props => {
  const {
    groupOnChangeHandlers = {},
    groupOnBlurHandlers = {}
  } = props;
  const eventHandlers = {
    groupOnBlurHandlers,
    groupOnChangeHandlers
  };
  return React.createElement(Stack, {
    space: 6
  }, PreExistingConditionsQuestions.map(preCondition => {
    return React.createElement(Field, {
      key: preCondition.id,
      name: preCondition.name,
      id: preCondition.id,
      component: YesNoRadio,
      label: preCondition.label,
      ...getGroupEventHandlerProps({
        ...eventHandlers,
        id: preCondition.id
      })
    });
  }));
};
PreExistingConditionsLeadQuestions.defaultProps = {
  groupOnChangeHandlers: {},
  groupOnBlurHandlers: {}
};
export default PreExistingConditionsLeadQuestions;